import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=46adc9ce&scoped=true"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=46adc9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46adc9ce",
  null
  
)

export default component.exports